/**
 * Declare this build's product identity for the shared @juristai packages.
 *
 * Imported first from src/index.js (and from src/setupTests.js so unit tests
 * see the same identity). juristai-home is the unified host: the active
 * dashboard route decides the appId at call time, so the existing
 * getCurrentAppId() stays the authority and the shared getAppId() delegates
 * to it.
 *
 * The utilities module is required lazily, when an appId is actually asked
 * for: importing it eagerly here drags axiosInstance (and real axios) into
 * every Jest environment via setupTests, ahead of the per-test axios mocks.
 */
import { configureProduct } from "@juristai/shared";

export const HOME_DEFAULT_APP_ID = "1";

configureProduct({
  appId: process.env.REACT_APP_APP_ID || HOME_DEFAULT_APP_ID,
  resolveAppId: () => require("./lib/apis/currentAppId").getCurrentAppId(),
  labels: { product: "JuristAI" },
  features: {
    // Home manages mailbox connections once for the user's account across apps.
    emailIntegrationsAccountScope: true,
  },
  // Shared API modules request through this app's own axiosInstance. Lazy for
  // the same reason as the resolver above.
  // The module (not .default) is returned so Jest manual mocks of any shape work.
  apiClient: () => require("./lib/apis/axiosInstance"),
  apiBaseUrl: () => require("./lib/apis/config").API_BASE_URL,
  // Shared API modules read the access token from this app's Redux store.
  store: () => require("./state/store"),
  // Shared API wrappers surface failures through this app's toast module.
  toast: () => require("./lib/utils/toast"),
});
